export function viewportToScrollView(documentViewer, viewPortPoint) {
  var scrollElement = documentViewer.getScrollViewElement();
  var scrollLeft = scrollElement.scrollLeft || 0;
  var scrollTop = scrollElement.scrollTop || 0;
  var scrollViewPoint = {
    x: viewPortPoint.x + scrollLeft,
    y: viewPortPoint.y + scrollTop
  };
  return scrollViewPoint;
}
export function getPageNumber(documentViewer, viewPortPoint) {
  var scrollViewPoint = viewportToScrollView(documentViewer, viewPortPoint);
  var displayMode = documentViewer.getDisplayModeManager().getDisplayMode();
  var page = displayMode.getSelectedPages(scrollViewPoint, scrollViewPoint);
  var pageNumber = page.first;
  return pageNumber;
}
export function viewportToPage(documentViewer, viewPortPoint, pageNumber) {
  var scrollViewPoint = viewportToScrollView(documentViewer, viewPortPoint);
  var displayMode = documentViewer.getDisplayModeManager().getDisplayMode();
  var pagePoint = displayMode.windowToPage(scrollViewPoint, pageNumber);
  return pagePoint;
}
export function rectFitsIntoPage(documentViewer, pageNumber, pagePoint, offsetRect) {
  var rotation = documentViewer.getCompleteRotation(pageNumber) * 90;
  var positionToBeObtained = {
    X: 0,
    Y: 0,
    Width: 0,
    Height: 0
  };
  initializeDroppedAnnotation(positionToBeObtained, pagePoint, offsetRect, rotation);
  if (positionToBeObtained.X < 0 || positionToBeObtained.Y < 0) {
    return false;
  }
  if (positionToBeObtained.X + positionToBeObtained.Width > documentViewer.getPageWidth(pageNumber)) {
    return false;
  }
  if (positionToBeObtained.Y + positionToBeObtained.Height > documentViewer.getPageHeight(pageNumber)) {
    return false;
  }
  return true;
}
export function initializeDroppedAnnotation(annotation, dropPoint, appearance, rotation) {
  if (rotation === 270 || rotation === 90) {
    annotation.Width = appearance.size.height;
    annotation.Height = appearance.size.width;
  } else {
    annotation.Width = appearance.size.width;
    annotation.Height = appearance.size.height;
  }
  if (rotation === 270) {
    annotation.X = dropPoint.x + appearance.offset.y - annotation.Width;
    annotation.Y = dropPoint.y - appearance.offset.x;
  } else if (rotation === 90) {
    annotation.X = dropPoint.x - appearance.offset.y;
    annotation.Y = dropPoint.y + appearance.offset.x - annotation.Height;
  } else if (rotation === 0) {
    annotation.X = dropPoint.x - appearance.offset.x;
    annotation.Y = dropPoint.y - appearance.offset.y;
  } else if (rotation === 180) {
    annotation.X = dropPoint.x + appearance.offset.x - annotation.Width;
    annotation.Y = dropPoint.y + appearance.offset.y - annotation.Height;
  }
}
export function getPlaceholderCoordinatesFromAnnotation(annotation, rotation, pageSize) {
  if (rotation === 0) {
    return {
      x: annotation.getX(),
      y: annotation.getY()
    };
  }
  if (rotation === 90) {
    return {
      x: pageSize.height - annotation.getY() - annotation.Height,
      y: annotation.getX()
    };
  }
  if (rotation === 180) {
    return {
      x: pageSize.width - annotation.getX() - annotation.Width,
      y: pageSize.height - annotation.getY() - annotation.Height
    };
  }
  if (rotation === 270) {
    return {
      x: annotation.getY(),
      y: pageSize.width - annotation.getX() - annotation.Width
    };
  }
  throw new Error('Incorrect page rotation value ' + String(rotation) + '. Allowed values are 0, 90, 180, 270');
}
export function getAnnotationCoordinatesFromPlaceholder(placeholderLocation, rotation, pageSize) {
  if (rotation === 0) {
    return placeholderLocation;
  }
  if (rotation === 90) {
    return {
      x: placeholderLocation.y,
      y: pageSize.height - placeholderLocation.x
    };
  }
  if (rotation === 180) {
    return {
      x: pageSize.width - placeholderLocation.x,
      y: pageSize.height - placeholderLocation.y
    };
  }
  if (rotation === 270) {
    return {
      x: pageSize.width - placeholderLocation.y,
      y: placeholderLocation.x
    };
  }
  throw new Error('Incorrect page rotation value ' + String(rotation) + '. Allowed values are 0, 90, 180, 270');
}
